var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCheckFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_992_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3214 1.39233C11.7291 1.39233 11.3009 1.6411 11.1317 1.89495C11.0471 1.97956 10.9786 2.15387 10.8939 2.23849H9.78294C8.85217 2.23849 8.09063 3.00003 8.09063 3.9308H6.39832C4.95986 3.9308 3.85986 5.0308 3.85986 6.46926V20.8539C3.85986 22.2923 4.95986 23.3923 6.39832 23.3923H18.2445C19.6829 23.3923 20.7829 22.2923 20.7829 20.8539V6.46926C20.7829 5.0308 19.6829 3.9308 18.2445 3.9308H16.5522C16.5522 3.00003 15.7906 2.23849 14.8599 2.23849H13.7489C13.6642 2.15387 13.5966 1.97956 13.5119 1.89495C13.3419 1.6411 12.9137 1.39233 12.3214 1.39233ZM9.78294 3.9308H14.8599V5.6231H9.78294V3.9308ZM6.39832 6.46926H8.35548C8.60932 6.97695 9.19063 7.31541 9.78294 7.31541H14.8599C15.4522 7.31541 16.0335 6.97695 16.2882 6.46926H18.2445V20.8539H6.39832V6.46926ZM15.3362 10.436C15.1772 10.436 15.0232 10.4936 14.9386 10.6205L11.2112 14.5873L9.78294 13.2385C9.52909 12.9846 9.10602 12.9846 8.93679 13.2385L8.35463 13.8206C8.10079 14.0745 8.10079 14.4976 8.35463 14.6668L10.7086 16.8871C11.0471 17.2256 11.5599 17.1198 11.8983 16.7813L16.4726 11.8906C16.6419 11.7213 16.6478 11.3769 16.3939 11.1231L15.7847 10.6205C15.7259 10.5616 15.6559 10.5149 15.579 10.4831C15.502 10.4513 15.4195 10.4359 15.3362 10.436Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_992_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.318848 0.745117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheckFill);
export default __webpack_public_path__ + "static/media/file_check_fill.c37cb6e8006400a6324017e40660331e.svg";
export { ForwardRef as ReactComponent };